module.exports = {
      id: "olympic-usage",
      viewBox: "0 0 11.388 19.966",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#olympic",
      toString: function () {
        return this.url;
      }
    }